export const AutoCrawlInvalidClients = 'AutoCrawlInvalidClients';
export const AutoCrawlStatus = 'AutoCrawlStatus';
export const DataValidationConsolidation = "DataValidationConsolidation";
export const FetchReConsolidationClients = "FetchReConsolidationClients";
export const FetchReConsolidationClientHeaderData = "FetchReConsolidationClientHeaderData";
export const UpdateClientHeader = "UpdateClientHeader";
export const OnChangeClientHeader = "OnChangeClientHeader";